import { __decorate } from "tslib";
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import styles from './rating.scss.js';
import '@cigna/cigna_csg_gsg_cipublic-tooltip/cipublic-tooltip.js';
/**
 * @element cipublic-rating
 */
export class Rating extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this);
        this.numberStars = 0;
        this.outOf = 0;
        this.toolHeading = '';
        this.toolContent = '';
    }
    static get styles() {
        return [styles];
    }
    populateStars(numberStars, outOf) {
        var _a, _b, _c, _d;
        const star = document.createElement('cipublic-icon');
        let starBlock = '';
        if (numberStars <= outOf) {
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.error-container')) === null || _b === void 0 ? void 0 : _b.classList.add('hide');
            for (let x = 0; x < (numberStars - (numberStars % 1)); x++) {
                star.setAttribute('name', 'star-filled-in');
                star.setAttribute('aria-hidden', 'true');
                starBlock += star.outerHTML;
            }
            if (numberStars % 1 >= 0.25 && numberStars % 1 < 0.75) {
                star.setAttribute('name', 'star-filled-half');
                star.setAttribute('aria-hidden', 'true');
                starBlock += star.outerHTML;
                outOf -= 1;
            }
            if (numberStars % 1 >= 0.75) {
                star.setAttribute('name', 'star-filled-in');
                star.setAttribute('aria-hidden', 'true');
                starBlock += star.outerHTML;
                outOf -= 1;
            }
            for (let y = 0; y < (outOf - (numberStars - (numberStars % 1))); y++) {
                star.setAttribute('name', 'star');
                star.setAttribute('aria-hidden', 'true');
                starBlock += star.outerHTML;
            }
        }
        else {
            (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.error-container')) === null || _d === void 0 ? void 0 : _d.classList.remove('hide');
            starBlock = '';
        }
        return html `${unsafeHTML(starBlock)}`;
    }
    addTooltip(toolHeading, toolContent) {
        if (toolHeading.length > 1) {
            return html `<cipublic-tooltip><span class="visually-hidden">${this.numberStars} ${this.i18n.t('of')} ${this.outOf}</span> <span class="leadin">${toolHeading}</span> <span slot="content">${toolContent}</span></cipublic-tooltip>`;
        }
        return;
    }
    render() {
        return html `${this.populateStars(this.numberStars, this.outOf)} ${this.addTooltip(this.toolHeading, this.toolContent)} <span class="error-container"><slot name="error"></slot></span>`;
    }
}
__decorate([
    property({ reflect: true, type: Number })
], Rating.prototype, "numberStars", void 0);
__decorate([
    property({ reflect: true, type: Number })
], Rating.prototype, "outOf", void 0);
__decorate([
    property({ reflect: true, type: String })
], Rating.prototype, "toolHeading", void 0);
__decorate([
    property({ reflect: true, type: String })
], Rating.prototype, "toolContent", void 0);
//# sourceMappingURL=rating.js.map